<div class="dashboardWidget medium">
  <a [routerLink]="['/support']" style="text-decoration: none">
    <div class="dashboardWrapper supportWidget">
      <div class="supportWidgetWrapper">

        <div class="oneNumberWidget outer text-center" style="width: 100%;">
          <div class="inner big-numbers">
            <i class="fa fa-life-ring" aria-hidden="true"></i>
          </div>
          <div class="widgetText text-center">
            <span>Support</span>
          </div>
        </div>
      </div>
    </div>
  </a>
</div>
